import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { JOB_STATES } from "@/api/types";
import { QueueDetailPage } from "@/features/queues/queue-detail-page";
import { baseListSearch, optionalEnum, optionalString } from "@/lib/list-state";

export const Route = createFileRoute("/_authenticated/queues/$queue/")({
  validateSearch: z.object({ ...baseListSearch, state: optionalEnum(JOB_STATES), job: optionalString }),
  head: () => ({ meta: [{ title: "Queue · Rogue Admin" }] }),
  component: QueueDetailPage,
});
